<template>

    <loader v-if="!loaded"></loader>
    <router-view
        v-else
        @updateTeamData="getTeamData"
    ></router-view>

</template>

<script>

import axios from 'axios';
import { mapActions } from 'vuex';
import Loader from "../../../components/Common/Loader";

export default {

    components: {
        Loader,
    },

    data() {
        return {
            loaded:false,
        }
    },

    destroyed(){
        this.setHrTeam({});
    },

    methods: {
        ...mapActions([
            'setHrTeam',
        ]),

        getTeamData() {
            axios.get(this.route('api.v1.hr.teams.show', {id: this.$route.params.id}))
                .then(resp => {
                    this.setHrTeam(resp.data.data);
                    this.loaded = true;
                });
        },
    },

    mounted(){
        this.getTeamData();
    },

    name:'HrTeamsLayout',

}

</script>
